<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <DeleteModal
      :show="show"
      @close="onCancel"
      name="Group"
      @submit="deletegroup"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
// import CongratulationsModal from "./CongratulationsModal";
import DeleteModal from "../Modals/DeleteModal.vue";

export default {
  name: "DeleteGroup",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      deletemssg: "",
      deleteErrormssg: "",
    };
  },
  components: {
    Loading,
    // CongratulationsModal,
    DeleteModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["deleteGroup"]),
    onCancel() {
      this.$emit("closeDeleteGroupModal");
    },
    deletegroup() {
      this.isLoading = true;
      this.deleteGroup({ id: this.$route.params.id })
        .then((res) => {
          this.isLoading = false;
          // this.deletemssg =
          //   res.data.message[0].toUpperCase() + res.data.message.slice(1);
          // setTimeout(() => {
          //   this.isLoading = true;
          // }, 1000);
          this.$router.push("/groups");
          // setTimeout(() => {
          // }, 2000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.deleteErrormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-content {
  overflow-y: inherit;
}
.modal-dialog {
  max-width: 500px !important;
}
</style>
